import React from "react"
import Die from "./Die"
import {nanoid} from "nanoid"
import Confetti from "react-confetti"

interface DieObj {
    value: number,
    isHeld: boolean,
    id: string
}

interface IState {
    dice: DieObj[],
    tenzies: boolean,
    diceRolls: number
}

export default function App() {

    const [dice, setDice] = React.useState<IState["dice"]>(allNewDice());
    const [tenzies, setTenzies] = React.useState<IState["tenzies"]>(false);
    const [diceRolls, setDiceRolls] = React.useState<IState["diceRolls"]>(0);
    
    React.useEffect(() => {
        const allHeld = dice.every(die => die.isHeld)
        const firstValue = dice[0]?.value
        const allSameValue = dice.every(die => die.value === firstValue)
        if (allHeld && allSameValue) {
            setTenzies(true)
        }
    }, [dice])

    function generateNewDie() : DieObj {
        return {
            value: Math.ceil(Math.random() * 6),
            isHeld: false,
            id: nanoid()
        }
    }
    
    function allNewDice() : DieObj[] {
        const newDice = []
        for (let i = 0; i < 10; i++) {
            newDice.push(generateNewDie())
        }
        return newDice
    }
    
    function rollDice() : void {
        if(!tenzies) {
            setDiceRolls(diceRolls => diceRolls + 1)
            setDice(oldDice => oldDice.map(die => {
                return die.isHeld ? 
                    die :
                    generateNewDie()
            }))
        } else {
            setTenzies(false)
            setDiceRolls(0)
            setDice(allNewDice())
        }
    }
    
    function holdDice(id : string) : void {
        setDice(oldDice => oldDice.map(die => {
            return die.id === id ? 
                {...die, isHeld: !die.isHeld} :
                die
        }))
    }
    
    const diceElements = dice.map(die => (
        <Die 
            key={die.id} 
            value={die.value} 
            isHeld={die.isHeld} 
            holdDice={() => holdDice(die.id)}
        />
    ))
    
    return (
        tenzies ? 
            <main>
                <Confetti />
                <h1>You won!</h1>
                <p>Dice Rolled: {diceRolls}</p>
                <button className="roll-dice" onClick={rollDice}>Play Again</button>
            </main> :
            <main>
                <h1 className="title">Tenzies</h1>
                <p className="instructions">Roll until all dice are the same. 
                Click each die to freeze it at its current value between rolls.</p>
                <div className="dice-container">
                    {diceElements}
                </div>
                <button className="roll-dice" onClick={rollDice}>Roll</button>
                <p className="dice-rolls">
                    "You rolled {diceRolls} times."
                </p>
            </main>
    )
}